import React, { Component } from 'react';

import ErrorPage from '../ErrorPage';

interface IState {
  isError: boolean;
}

interface IProps {
  children?: React.ReactNode;
}

class ErrorBoundary extends Component<IProps, IState> {
  public state = { isError: false };

  public componentDidCatch() {
    this.setState({ isError: true });
  }

  public render() {
    const { isError } = this.state;
    const { children } = this.props;

    const handleActionClick = () => {
      document.location.reload();
    };

    return (
      <>
        {isError ? (
          <ErrorPage
            text="Что-то пошло не так…"
            description="Не переживайте, мы знаем об этом и скоро всё поправим!"
            actionSecondary="На главную"
            actionSecondaryOnClick={() => document.location.replace('/')}
            action="Попробовать ещё раз"
            actionOnClick={handleActionClick}
          />
        ) : (
          children
        )}
      </>
    );
  }
}

export default ErrorBoundary;
